export {};
//# sourceMappingURL=evaluate-audio-worklet-global-scope-function.js.map